module.exports = ".navbar-wrapper {\n  margin: auto; }\n  .navbar-wrapper .navbar-brand {\n    font-size: 2em;\n    color: white;\n    font-weight: 400; }\n"